// Paw Supplies Group - Premium Pet Accessories & Equipment
// Brand operator: Radan Capital Management LLC
// pawsuppliesgroup.com

// ============================================
// SITE IMAGES - Pet-Friendly Warm Theme
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1543466835-00a7907e9de1?q=80&w=2669&auto=format&fit=crop',
  heroSecondary: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=2670&auto=format&fit=crop',
  heroLifestyle: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?q=80&w=2670&auto=format&fit=crop',
  ctaBackground: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?q=80&w=2670&auto=format&fit=crop',
  featuredBackground: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?q=80&w=2670&auto=format&fit=crop',
  powerBackground: 'https://images.unsplash.com/photo-1444212477490-ca407925329e?q=80&w=2670&auto=format&fit=crop',
  shopBanner: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=2670&auto=format&fit=crop',
  aboutBanner: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?q=80&w=2670&auto=format&fit=crop',
  contactBanner: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?q=80&w=2670&auto=format&fit=crop',
  returnsBanner: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?q=80&w=2670&auto=format&fit=crop',
  privacyBanner: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?q=80&w=2670&auto=format&fit=crop',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on every order

export const CARD_DESCRIPTOR = 'PAW SUPPLIES GROUP';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(855) 643-9861',
  email: 'contact@pawsuppliesgroup.com',
  corpName: 'Radan Capital Management LLC',
  address: {
    street: '547 E Altgeld Ave',
    city: 'Glendale Heights',
    state: 'IL',
    zip: '60139',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '547 E Altgeld Ave',
  city: 'Glendale Heights',
  state: 'IL',
  zip: '60139',
  country: 'USA'
};

// ============================================
// PET PRODUCT CATALOG (12 Products / 4 Categories)
// ============================================
export const products = [
  // ===== LIVING =====
  {
    id: "plastic-dog-carrier",
    name: "Plastic Dog Carrier",
    slug: "plastic-dog-carrier",
    sku: "PSG-LIV-001",
    price: 120.08,
    image: "https://scoobypetsupply.com/images/products/prod-3.png",
    badge: "Travel Ready",
    categoryId: "living",
    categorySlug: "living",
    description: "Take your pup on the road in comfort with this sturdy plastic dog carrier. Ventilated sides, a secure latching door and a non-slip floor help keep your dog calm and safe during car rides, vet visits and travel.",
    keyBenefits: ["Hard-shell protective build", "Ventilation on all sides", "Secure metal-grille door"],
    usage: "Ideal for car trips, vet appointments, grooming visits and short-haul air-friendly travel for small to medium dogs.",
    features: ["Hard-Shell", "Ventilated", "Easy-Clean", "Locking Door"],
    inStock: true
  },
  {
    id: "living-room-home-for-pets",
    name: "Living Room Home for Pets",
    slug: "living-room-home-for-pets",
    sku: "PSG-LIV-002",
    price: 213.32,
    image: "https://scoobypetsupply.com/images/products/prod-5.png",
    badge: "Best Seller",
    categoryId: "living",
    categorySlug: "living",
    description: "Give your cat or small dog a cozy living-room hideaway. This indoor pet condo blends into modern home decor with a soft cushion, a private nook and a stable, easy-to-clean base.",
    keyBenefits: ["Cozy private hideaway", "Blends into home decor", "Soft removable cushion"],
    usage: "Place in your living room, bedroom or office to give your cat or small dog a dedicated relaxation spot.",
    features: ["Indoor Use", "Soft Cushion", "Easy Clean", "Modern Look"],
    inStock: true
  },
  {
    id: "basic-hooded-litter-pan",
    name: "Basic Hooded Litter Pan",
    slug: "basic-hooded-litter-pan",
    sku: "PSG-LIV-003",
    price: 34.98,
    image: "https://scoobypetsupply.com/images/products/prod-10.png",
    badge: "Cat Essential",
    categoryId: "living",
    categorySlug: "living",
    description: "Keep your home fresher with this hooded litter pan. The lift-off top contains odors and stray litter while giving your cat a quiet, private space to do their business.",
    keyBenefits: ["Helps contain odors", "Hood limits scatter", "Easy snap-on top"],
    usage: "Set in a quiet corner of your home, fill with your cat's preferred litter and lift the hood for fast daily cleaning.",
    features: ["Hooded", "Odor Control", "Easy Clean", "Snap Latches"],
    inStock: true
  },
  {
    id: "basic-nylon-dog-collar",
    name: "Basic Nylon Dog Collar",
    slug: "basic-nylon-dog-collar",
    sku: "PSG-LIV-004",
    price: 17.98,
    image: "https://scoobypetsupply.com/images/products/prod-9.png",
    badge: "Everyday",
    categoryId: "living",
    categorySlug: "living",
    description: "A reliable everyday nylon collar with a sturdy quick-release buckle and a strong D-ring for tags and leashes. Adjustable sizing makes it a great fit for growing dogs.",
    keyBenefits: ["Quick-release safety buckle", "Durable woven nylon", "Adjustable fit"],
    usage: "Fit snugly so you can slide two fingers under the collar; attach ID tags and your favorite leash.",
    features: ["Adjustable", "D-Ring", "Quick-Release", "Soft Nylon"],
    inStock: true
  },
  {
    id: "basic-nylon-dog-lead-leash",
    name: "Basic Nylon Dog Lead Leash",
    slug: "basic-nylon-dog-lead-leash",
    sku: "PSG-LIV-005",
    price: 26.97,
    image: "https://scoobypetsupply.com/images/products/prod-8.png",
    badge: "Walks Ready",
    categoryId: "living",
    categorySlug: "living",
    description: "This dependable nylon lead leash gives you confident control on every walk. A padded handle keeps your hand comfortable and a strong swivel clip stays secure on collars and harnesses.",
    keyBenefits: ["Padded handle for comfort", "Strong swivel clip", "Tangle-resistant nylon"],
    usage: "Clip onto your dog's collar or harness for daily walks, training sessions and trips to the park.",
    features: ["Padded Handle", "Swivel Clip", "Tough Nylon", "Lightweight"],
    inStock: true
  },

  // ===== FEEDING =====
  {
    id: "pet-feeder-water-bowl",
    name: "Pet Feeder Water Bowl",
    slug: "pet-feeder-water-bowl",
    sku: "PSG-FED-001",
    price: 17.49,
    image: "https://scoobypetsupply.com/images/products/prod-1.png",
    badge: "Top Pick",
    categoryId: "feeding",
    categorySlug: "feeding",
    description: "Keep food and water within reach with this convenient pet feeder bowl. The wide base resists tipping and the easy-clean interior makes daily refills simple for busy pet parents.",
    keyBenefits: ["Non-slip stable base", "Easy to refill & clean", "Comfortable feeding height"],
    usage: "Place in your pet's regular feeding spot, fill with fresh food or water, and rinse between meals.",
    features: ["Non-Slip", "Easy-Clean", "Tip-Resistant", "Pet-Safe"],
    inStock: true
  },

  // ===== SLEEPING =====
  {
    id: "round-dog-bed",
    name: "Round Dog Bed",
    slug: "round-dog-bed",
    sku: "PSG-SLP-001",
    price: 52.47,
    image: "https://scoobypetsupply.com/images/products/prod-2.png",
    badge: "Cozy Comfort",
    categoryId: "sleeping",
    categorySlug: "sleeping",
    description: "A plush round dog bed with a soft raised rim that gives your pup a sense of security while they nap. The cushioned interior cradles joints for deep, restful sleep.",
    keyBenefits: ["Plush raised rim", "Cushioned sleeping surface", "Cozy donut-style design"],
    usage: "Set in your favorite living-room corner, bedroom or crate to give your dog a soft place to curl up.",
    features: ["Plush Rim", "Soft Fill", "Non-Slip Base", "Machine-Wash Cover"],
    inStock: true
  },
  {
    id: "deluxe-bolster-pet-bed",
    name: "Deluxe Bolster Pet Bed",
    slug: "deluxe-bolster-pet-bed",
    sku: "PSG-SLP-002",
    price: 35.96,
    image: "https://scoobypetsupply.com/images/products/prod-7.png",
    badge: "Customer Favorite",
    categoryId: "sleeping",
    categorySlug: "sleeping",
    description: "This deluxe bolster bed features high-walled cushioned sides that offer head and neck support, plus a soft interior cushion your pet will love sinking into.",
    keyBenefits: ["Supportive bolster walls", "Soft sleep surface", "Removable cushion"],
    usage: "Position against a wall or in a corner so your pet can lean into the bolster while sleeping.",
    features: ["Bolster Sides", "Soft Cushion", "Easy-Clean Cover", "Anti-Slip Base"],
    inStock: true
  },
  {
    id: "orthopedic-dog-bed",
    name: "Orthopedic Dog Bed",
    slug: "orthopedic-dog-bed",
    sku: "PSG-SLP-003",
    price: 69.96,
    image: "https://scoobypetsupply.com/images/products/prod-11.png",
    badge: "Joint Support",
    categoryId: "sleeping",
    categorySlug: "sleeping",
    description: "Help your older or larger dog rest easy on this orthopedic dog bed. A thick foam base supports tired joints while the soft cover stays cozy night after night.",
    keyBenefits: ["Thick supportive foam", "Joint pressure relief", "Soft removable cover"],
    usage: "A great choice for senior dogs, large breeds or any pup that needs extra joint support during sleep.",
    features: ["Orthopedic Foam", "Removable Cover", "Non-Slip Base", "Hypoallergenic"],
    inStock: true
  },

  // ===== PLAYTIME =====
  {
    id: "assorted-feathers-cat-toy",
    name: "Assorted Feathers Cat Toy",
    slug: "assorted-feathers-cat-toy",
    sku: "PSG-PLY-001",
    price: 11.49,
    image: "https://scoobypetsupply.com/images/products/prod-4.png",
    badge: "Fun Pick",
    categoryId: "playtime",
    categorySlug: "playtime",
    description: "A colorful set of feather cat toys designed to spark your cat's hunting instincts. Lightweight, easy to bat around and perfect for daily indoor play sessions.",
    keyBenefits: ["Encourages active play", "Lightweight & easy to chase", "Colorful assorted feathers"],
    usage: "Toss across the floor, drag along the carpet or attach to a wand for engaging interactive play.",
    features: ["Assorted Colors", "Lightweight", "Indoor Play", "Cat-Friendly"],
    inStock: true
  },
  {
    id: "exercise-ball-for-small-pets",
    name: "Exercise Ball for Small Pets",
    slug: "exercise-ball-for-small-pets",
    sku: "PSG-PLY-002",
    price: 8.99,
    image: "https://scoobypetsupply.com/images/products/prod-6.png",
    badge: "Value Pick",
    categoryId: "playtime",
    categorySlug: "playtime",
    description: "A safe exercise ball for hamsters, gerbils and other small pets. The breathable design lets your little explorer roll around the room while staying contained and entertained.",
    keyBenefits: ["Safe out-of-cage exercise", "Breathable ventilation slots", "Secure locking door"],
    usage: "Place your small pet inside, snap the door shut and let them roam a pet-safe, hazard-free area of the room.",
    features: ["Small Pets", "Ventilated", "Locking Door", "Easy Clean"],
    inStock: true
  },
  {
    id: "interactive-cat-toys",
    name: "Interactive Cat Toys",
    slug: "interactive-cat-toys",
    sku: "PSG-PLY-003",
    price: 239.94,
    image: "https://scoobypetsupply.com/images/products/prod-12.png",
    badge: "Premium Set",
    categoryId: "playtime",
    categorySlug: "playtime",
    description: "A premium bundle of interactive cat toys built to challenge curious feline minds. Includes engaging play tracks, sensory teasers and motion-based toys to keep indoor cats active.",
    keyBenefits: ["Mental enrichment", "Multi-toy bundle", "Keeps indoor cats active"],
    usage: "Rotate the toys throughout the week to keep playtime fresh and prevent boredom in indoor cats.",
    features: ["Bundle Set", "Interactive", "Mentally Stimulating", "Indoor Play"],
    inStock: true
  },
];

// ============================================
// CATEGORIES (4)
// ============================================
export const categories = [
  {
    id: "living",
    name: "Living",
    slug: "living",
    description: "Carriers, condos, collars, leashes and litter pans for everyday pet living",
    image: "https://scoobypetsupply.com/images/products/prod-5.png",
    productCount: 5
  },
  {
    id: "feeding",
    name: "Feeding",
    slug: "feeding",
    description: "Feeders and water bowls for daily meals and hydration",
    image: "https://scoobypetsupply.com/images/products/prod-1.png",
    productCount: 1
  },
  {
    id: "sleeping",
    name: "Sleeping",
    slug: "sleeping",
    description: "Plush dog beds, bolster beds and orthopedic beds for restful sleep",
    image: "https://scoobypetsupply.com/images/products/prod-11.png",
    productCount: 3
  },
  {
    id: "playtime",
    name: "Playtime",
    slug: "playtime",
    description: "Cat toys, exercise balls and interactive play bundles for happy pets",
    image: "https://scoobypetsupply.com/images/products/prod-12.png",
    productCount: 3
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Pet-Approved Quality', description: 'Hand-picked pet accessories your dog or cat will love' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS shipping on every order' },
  { id: 3, title: '30-Day Returns', description: 'Easy returns within 30 days, no hassle' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and protected customer data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Convenience', description: 'Pet feeders, bowls and beds that make daily care easier for busy pet parents' },
  { id: 2, title: 'Enrichment', description: 'Interactive toys and exercise gear that keep pets engaged and active' },
  { id: 3, title: 'Comfort', description: 'Cozy beds and bolstered sleeping spaces designed for restful naps' },
  { id: 4, title: 'Trust', description: 'Curated pet products from a team that cares about pets like family' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated pet accessories across Living, Feeding, Sleeping and Playtime.' },
  { id: 2, title: 'Pick', description: 'Choose the bed, toy, feeder or carrier that fits your pet best.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with secure, encrypted payment.' },
  { id: 4, title: 'Pamper', description: 'Unbox and treat your best friend to something they will love.' }
];
